import {IMultiSetsPromotionInterface, PromotionLogic} from '@gongxigames/framework/promotions';

export class MultiSetsPromotionLogic extends PromotionLogic<IMultiSetsPromotionInterface> {
    public accept(callback: () => void): void {
        this.promotionInterface.setChoice('accept', callback);
    }

    public reject(callback: () => void): void {
        this.promotionInterface.setChoice('ask_me_later', callback);
    }

    public end(): void {
        this.promotionInterface.end();
    }
}
